export default "__VITE_ASSET__DDEoh3rS__"